let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("khsl0")).then(() => parcelRequire('ajrUa'));